import { useQuery } from "@tanstack/react-query";
import { cmsServices } from "features/cms/services/cms.service";

export const usePublicCmsPage = (slug) => {
  return useQuery({
    queryKey: ["publicCmsPage", slug],
    queryFn: async () => {
      // console.log('Fetching CMS page for slug:', slug);
      try {
        const data = await cmsServices.getPublicCmsPage(slug);
        // console.log('CMS page data received:', data);
        return data;
      } catch (error) {
        console.error('Error fetching CMS page:', error);
        console.error('Error response:', error?.response?.data);
        throw error;
      }
    },
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  });
};
